{{extend './form_line.art'}}
{{block 'line'}}
<input type="number" name="{{ attr.name }}"{{if (data.readonly)}} readonly {{/if}}{{if (data.value)}}value="{{data.value}}" {{/if}}{{if attr.other}} {{@ attr.other}}{{/if}}>
{{/block}}